import { PageLinkComponentProps } from "@omni/ui/components/PageLink/pageLink.props";
import { cn } from "@omni/utils/styles";

import { LogoutLinkContainer } from "@/components/Account/LogoutLink/logoutLink.container";
import { Anchor } from "@/components/General/Anchor/anchor.component";

type Props = {
    pageLinks: Array<PageLinkComponentProps>;
};

export const LoggedInLinks = ({ pageLinks }: Props) => {
    return (
        <>
            {pageLinks.map(({ link, label }, index) => (
                <Anchor
                    key={`${link}-${index}`}
                    href={link}
                    color={"link"}
                    fullWidth={true}
                    className={cn("tw:px-4 tw:py-2 tw:text-left")}
                >
                    {label}
                </Anchor>
            ))}
            <LogoutLinkContainer
                className={cn(
                    "tw:block tw:py-2 tw:px-4 tw:no-underline tw:text-information",
                    "tw:hover:underline tw:hover:text-information-focus"
                )}
            />
        </>
    );
};
